import { DealStatus } from "@/app/api/types";
import { DealStatusChip } from "@/shared/deal-status-chip";
import { Stack, SxProps, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  status: DealStatus;
  sx?: SxProps;
}

export const CreateSellerRequestStatus: FC<Props> = ({ sx, status }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" sx={sx} alignItems="center" spacing={0.5}>
      <Typography fontSize={14} fontWeight={500}>
        {t("status")}:
      </Typography>

      <DealStatusChip type="seller" status={status} />
    </Stack>
  );
};
